import Page from '@app/components/layout/page/page';
import PurchasedPackagingItemForm from '../components/item/purchased-packaging-item-form';
import { usePurchasedPackagingItem } from '../purchased-packaging-item-context';

export default function PurchasedPackagingItemPage() {
  const { item, status } = usePurchasedPackagingItem();
  return (
    <Page name="Packaging" page="subpage" status={status} flexFullHeight>
      <PurchasedPackagingItemForm item={item} />
    </Page>
  );
}
